const COUNTRY_CODES = [
  {
    country: "Dominican Republic",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "DO",
    code: "1809",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Dominican Republic",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "DO",
    code: "1829",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Dominican Republic",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "DO",
    code: "1849",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Jamaica",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "JM",
    code: "1658",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Jamaica",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "JM",
    code: "1876",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Puerto Rico",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "PR",
    code: "1787",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Puerto Rico",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "PR",
    code: "1939",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Mexico",
    region: "Mexico",
    marketing: 0.0436,
    utility: 0.0266,
    authentication: 0.0239,
    service: 0.0105,
    nameCode: "MX",
    code: "52",
    user_initiated: 0.0105,
    business_initiated: 0.0349,
  },
  {
    country: "Argentina",
    region: "Argentina",
    marketing: 0.0618,
    utility: 0.0408,
    authentication: 0.0367,
    service: 0.0316,
    nameCode: "AR",
    code: "54",
    user_initiated: 0.0316,
    business_initiated: 0.0526,
  },
  {
    country: "Albania",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "AL",
    code: "355",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Algeria",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "DZ",
    code: "213",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Angola",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "AO",
    code: "244",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Armenia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "AM",
    code: "374",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Azerbaijan",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "AZ",
    code: "994",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Bahrain",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "BH",
    code: "973",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Bangladesh",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "BD",
    code: "880",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Belarus",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "BY",
    code: "375",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Benin",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "BJ",
    code: "229",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Bolivia",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "BO",
    code: "591",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Botswana",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "BW",
    code: "267",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Bulgaria",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "BG",
    code: "359",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Burkina Faso",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "BF",
    code: "226",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Burundi",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "BI",
    code: "257",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Cambodia",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "KH",
    code: "855",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Cameroon",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "CM",
    code: "237",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Chad",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "TD",
    code: "235",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Costa Rica",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "CR",
    code: "506",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Croatia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "HR",
    code: "385",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Czech Republic",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "CZ",
    code: "420",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Ecuador",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "EC",
    code: "593",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "El Salvador",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "SV",
    code: "503",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Eritrea",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "ER",
    code: "291",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Ethiopia",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "ET",
    code: "251",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Finland",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "FI",
    code: "358",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Gabon",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "GA",
    code: "241",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Gambia",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "GM",
    code: "220",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Georgia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "GE",
    code: "995",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Ghana",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "GH",
    code: "233",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Guatemala",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "GT",
    code: "502",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Guinea-Bissau",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "GW",
    code: "245",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Haiti",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "HT",
    code: "509",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Honduras",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "HN",
    code: "504",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Hong Kong",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "HK",
    code: "852",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Iraq",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "IQ",
    code: "964",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Ireland",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "IE",
    code: "353",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Israel",
    region: "Israel",
    marketing: 0.0353,
    utility: 0.0188,
    authentication: 0.0169,
    service: 0.018,
    nameCode: "IL",
    code: "972",
    user_initiated: 0.018,
    business_initiated: 0.03,
  },
  {
    country: "Ivory Coast",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "CI",
    code: "225",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Jordan",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "JO",
    code: "962",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Kenya",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "KE",
    code: "254",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Kuwait",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "KW",
    code: "965",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Laos",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "LA",
    code: "856",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Latvia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "LV",
    code: "371",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Lebanon",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "LB",
    code: "961",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Lesotho",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "LS",
    code: "266",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Liberia",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "LR",
    code: "231",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Libya",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "LY",
    code: "218",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Lithuania",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "LT",
    code: "370",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Madagascar",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "MG",
    code: "261",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Malawi",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "MW",
    code: "265",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Mali",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "ML",
    code: "223",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Mauritania",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "MR",
    code: "222",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Moldova",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "MD",
    code: "373",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Mongolia",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "MN",
    code: "976",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Morocco",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "MA",
    code: "212",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Mozambique",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "MZ",
    code: "258",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Namibia",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "NA",
    code: "264",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Nepal",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "NP",
    code: "977",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Nicaragua",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "NI",
    code: "505",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Niger",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "NE",
    code: "227",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Nigeria",
    region: "Nigeria",
    marketing: 0.0516,
    utility: 0.0319,
    authentication: 0.0287,
    service: 0.031,
    nameCode: "NG",
    code: "234",
    user_initiated: 0.031,
    business_initiated: 0.0516,
  },
  {
    country: "North Macedonia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "MK",
    code: "389",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Oman",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "OM",
    code: "968",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Panama",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "PA",
    code: "507",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Papua New Guinea",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "PG",
    code: "675",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Paraguay",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "PY",
    code: "595",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Portugal",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "PT",
    code: "351",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Qatar",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "QA",
    code: "974",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Republic of the Congo (Brazzaville)",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "CG",
    code: "242",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Rwanda",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "RW",
    code: "250",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Saudi Arabia",
    region: "Saudi Arabia",
    marketing: 0.0406,
    utility: 0.0252,
    authentication: 0.0226,
    service: 0.0195,
    nameCode: "SA",
    code: "966",
    user_initiated: 0.0195,
    business_initiated: 0.0325,
  },
  {
    country: "Senegal",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "SN",
    code: "221",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Serbia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "RS",
    code: "381",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Sierra Leone",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "SL",
    code: "232",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Slovakia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "SK",
    code: "421",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Slovenia",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "SI",
    code: "386",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Somalia",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "SO",
    code: "252",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "South Sudan",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "SS",
    code: "211",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Sudan",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "SD",
    code: "249",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Swaziland",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "SZ",
    code: "268",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Taiwan",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "TW",
    code: "886",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Tajikistan",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "TJ",
    code: "992",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Tanzania",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "TZ",
    code: "255",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Togo",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "TG",
    code: "228",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Tunisia",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "TN",
    code: "216",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Turkmenistan",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "TM",
    code: "993",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Uganda",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "UG",
    code: "256",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Ukraine",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "UA",
    code: "380",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "United Arab Emirates",
    region: "United Arab Emirates",
    marketing: 0.034,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.019,
    nameCode: "AE",
    code: "971",
    user_initiated: 0.019,
    business_initiated: 0.0316,
  },
  {
    country: "Uruguay",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "UY",
    code: "598",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Uzbekistan",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "UZ",
    code: "998",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Yemen",
    region: "Rest of Middle East",
    marketing: 0.0341,
    utility: 0.0198,
    authentication: 0.0178,
    service: 0.0218,
    nameCode: "YE",
    code: "967",
    user_initiated: 0.0218,
    business_initiated: 0.0727,
  },
  {
    country: "Zambia",
    region: "Rest of Africa",
    marketing: 0.0225,
    utility: 0.016,
    authentication: 0.0144,
    service: 0.0363,
    nameCode: "ZM",
    code: "260",
    user_initiated: 0.0363,
    business_initiated: 0.1208,
  },
  {
    country: "Afghanistan",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "AF",
    code: "93",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Australia",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "AU",
    code: "61",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Austria",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "AT",
    code: "43",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Belgium",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "BE",
    code: "32",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Brazil",
    region: "Brazil",
    marketing: 0.0625,
    utility: 0.035,
    authentication: 0.0315,
    service: 0.03,
    nameCode: "BR",
    code: "55",
    user_initiated: 0.03,
    business_initiated: 0.05,
  },
  {
    country: "Chile",
    region: "Chile",
    marketing: 0.0889,
    utility: 0.0586,
    authentication: 0.0527,
    service: 0.0454,
    nameCode: "CL",
    code: "56",
    user_initiated: 0.0454,
    business_initiated: 0.0757,
  },
  {
    country: "China",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "CN",
    code: "86",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Colombia",
    region: "Colombia",
    marketing: 0.0125,
    utility: 0.0085,
    authentication: 0.0077,
    service: 0.006,
    nameCode: "CO",
    code: "57",
    user_initiated: 0.006,
    business_initiated: 0.01,
  },
  {
    country: "Denmark",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "DK",
    code: "45",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Egypt",
    region: "Egypt",
    marketing: 0.1073,
    utility: 0.0687,
    authentication: 0.0618,
    service: 0.0644,
    nameCode: "EG",
    code: "20",
    user_initiated: 0.0644,
    business_initiated: 0.1073,
  },
  {
    country: "France",
    region: "France",
    marketing: 0.1432,
    utility: 0.0768,
    authentication: 0.0691,
    service: 0.0859,
    nameCode: "FR",
    code: "33",
    user_initiated: 0.0859,
    business_initiated: 0.1432,
  },
  {
    country: "Germany",
    region: "Germany",
    marketing: 0.1365,
    utility: 0.0853,
    authentication: 0.0768,
    service: 0.0819,
    nameCode: "DE",
    code: "49",
    user_initiated: 0.0819,
    business_initiated: 0.1365,
  },
  {
    country: "Greece",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "GR",
    code: "30",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Hungary",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "HU",
    code: "36",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "India",
    region: "India",
    marketing: 0.0099,
    utility: 0.0042,
    authentication: 0.0042,
    service: 0.004,
    nameCode: "IN",
    code: "91",
    user_initiated: 0.004,
    business_initiated: 0.0066,
  },
  {
    country: "Indonesia",
    region: "Indonesia",
    marketing: 0.0411,
    utility: 0.02,
    authentication: 0.03,
    service: 0.019,
    nameCode: "ID",
    code: "62",
    user_initiated: 0.019,
    business_initiated: 0.0316,
  },
  {
    country: "Italy",
    region: "Italy",
    marketing: 0.0691,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0386,
    nameCode: "IT",
    code: "39",
    user_initiated: 0.0386,
    business_initiated: 0.0643,
  },
  {
    country: "Japan",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "JP",
    code: "81",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Malaysia",
    region: "Malaysia",
    marketing: 0.086,
    utility: 0.02,
    authentication: 0.018,
    service: 0.022,
    nameCode: "MY",
    code: "60",
    user_initiated: 0.022,
    business_initiated: 0.0732,
  },
  {
    country: "Netherlands",
    region: "Netherlands",
    marketing: 0.1597,
    utility: 0.08,
    authentication: 0.072,
    service: 0.0891,
    nameCode: "NL",
    code: "31",
    user_initiated: 0.0891,
    business_initiated: 0.1485,
  },
  {
    country: "New Zealand",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "NZ",
    code: "64",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Norway",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "NO",
    code: "47",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Pakistan",
    region: "Pakistan",
    marketing: 0.0473,
    utility: 0.0253,
    authentication: 0.0228,
    service: 0.0142,
    nameCode: "PK",
    code: "92",
    user_initiated: 0.0142,
    business_initiated: 0.0473,
  },
  {
    country: "Peru",
    region: "Peru",
    marketing: 0.0703,
    utility: 0.0419,
    authentication: 0.0377,
    service: 0.0179,
    nameCode: "PE",
    code: "51",
    user_initiated: 0.0179,
    business_initiated: 0.0598,
  },
  {
    country: "Philippines",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "PH",
    code: "63",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Poland",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "PL",
    code: "48",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Romania",
    region: "Rest of Central & Eastern Europe",
    marketing: 0.086,
    utility: 0.0619,
    authentication: 0.0557,
    service: 0.025,
    nameCode: "RO",
    code: "40",
    user_initiated: 0.025,
    business_initiated: 0.0835,
  },
  {
    country: "Singapore",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "SG",
    code: "65",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "South Africa",
    region: "South Africa",
    marketing: 0.0379,
    utility: 0.02,
    authentication: 0.018,
    service: 0.0168,
    nameCode: "ZA",
    code: "27",
    user_initiated: 0.0168,
    business_initiated: 0.028,
  },
  {
    country: "España",
    region: "Spain",
    marketing: 0.0615,
    utility: 0.038,
    authentication: 0.0342,
    service: 0.0369,
    nameCode: "ES",
    code: "34",
    user_initiated: 0.0369,
    business_initiated: 0.0615,
  },
  {
    country: "Sri Lanka",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "LK",
    code: "94",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Sweden",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "SE",
    code: "46",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Switzerland",
    region: "Rest of Western Europe",
    marketing: 0.0592,
    utility: 0.042,
    authentication: 0.0378,
    service: 0.0397,
    nameCode: "CH",
    code: "41",
    user_initiated: 0.0397,
    business_initiated: 0.1324,
  },
  {
    country: "Thailand",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "TH",
    code: "66",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Turkey",
    region: "Turkey",
    marketing: 0.0109,
    utility: 0.0093,
    authentication: 0.0083,
    service: 0.003,
    nameCode: "TR",
    code: "90",
    user_initiated: 0.003,
    business_initiated: 0.01,
  },
  {
    country: "United Kingdom",
    region: "United Kingdom",
    marketing: 0.0705,
    utility: 0.0398,
    authentication: 0.0358,
    service: 0.0388,
    nameCode: "GB",
    code: "44",
    user_initiated: 0.0388,
    business_initiated: 0.0647,
  },
  {
    country: "Venezuela",
    region: "Rest of Latin America",
    marketing: 0.074,
    utility: 0.0494,
    authentication: 0.0445,
    service: 0.0423,
    nameCode: "VE",
    code: "58",
    user_initiated: 0.0423,
    business_initiated: 0.0706,
  },
  {
    country: "Vietnam",
    region: "Rest of Asia Pacific",
    marketing: 0.0732,
    utility: 0.0472,
    authentication: 0.0425,
    service: 0.0224,
    nameCode: "VN",
    code: "84",
    user_initiated: 0.0224,
    business_initiated: 0.0745,
  },
  {
    country: "Canada",
    region: "North America",
    marketing: 0.025,
    utility: 0.015,
    authentication: 0.0135,
    service: 0.0088,
    nameCode: "CA",
    code: "1",
    user_initiated: 0.0088,
    business_initiated: 0.0147,
  },
  {
    country: "Russia",
    region: "Russia",
    marketing: 0.0802,
    utility: 0.0477,
    authentication: 0.0429,
    service: 0.0398,
    nameCode: "RU",
    code: "7",
    user_initiated: 0.0398,
    business_initiated: 0.0663,
  },
  {
    country: "United States",
    region: "North America",
    marketing: 0.025,
    utility: 0.015,
    authentication: 0.0135,
    service: 0.0088,
    nameCode: "US",
    code: "1",
    user_initiated: 0.0088,
    business_initiated: 0.0147,
  },
];

export default COUNTRY_CODES;
